/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../../clients/baseClient'
import type { RequestConfig, ResponseErrorConfig } from '../../../../clients/baseClient'
import type {
  ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationResponse,
  ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeletePathParams,
  ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteHeaderParams,
  ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete422,
} from '../../types/ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete.ts'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { useMutation } from '@tanstack/react-query'

export const replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationKey = () => [{ url: '/api/v1/reply_schedule/{reply_schedule_id}' }] as const

export type ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationKey = ReturnType<
  typeof replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationKey
>

/**
 * @summary Reply Schedule Delete
 * {@link /api/v1/reply_schedule/:reply_schedule_id}
 */
export async function replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete(
  reply_schedule_id: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeletePathParams['reply_schedule_id'],
  headers?: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationResponse,
    ResponseErrorConfig<ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete422>,
    unknown
  >({ method: 'DELETE', url: `/api/v1/reply_schedule/${reply_schedule_id}`, ...requestConfig, headers: { ...headers, ...requestConfig.headers } })
  return res.data
}

/**
 * @summary Reply Schedule Delete
 * {@link /api/v1/reply_schedule/:reply_schedule_id}
 */
export function useReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationResponse,
      ResponseErrorConfig<ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete422>,
      {
        reply_schedule_id: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeletePathParams['reply_schedule_id']
        headers?: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteHeaderParams
      },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof fetch }
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationKey()

  return useMutation<
    ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteMutationResponse,
    ResponseErrorConfig<ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete422>,
    {
      reply_schedule_id: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeletePathParams['reply_schedule_id']
      headers?: ReplyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDeleteHeaderParams
    },
    TContext
  >(
    {
      mutationFn: async ({ reply_schedule_id, headers }) => {
        return replyScheduleDeleteApiV1ReplyScheduleReplyScheduleIdDelete(reply_schedule_id, headers, config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}